export const REGISTER_USER = "register_user"
export const UPDATE_USER = "UPDATE_USER"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const DELETE_USER_SETTINGS = 'DELETE_USER_SETTINGS'
export const SET_CURRENT_MEMBER = 'SET_CURRENT_MEMBER'
